import FreelancerExportDashboard from "../../components/admin/FreelancerExportDashboard";

const FreelancerExport = () => {
  return <FreelancerExportDashboard />;
};

export default FreelancerExport;
